
import React from 'react'
import { Component } from 'react'

import _ from 'lodash';

import QueryMatrix from './QueryMatrix'
import SearchResults from './SearchResults'
import { getHashParams, columnsToHash, hashToColumns } from "../queryParams";
import SearchLink from "./SearchLink";
import BriefTitle from './BriefTitle'
import Selector from "./Selector";
import ZitatPopup from "./ZitatPopup"
import MultiSelector from "./MultiSelector";
import BriefStats from "./BriefStats";
import Tabs from "./Tabs";
import Spinner from "./LoadingSpinner";
import ApexTimeline from "./ApexTimeline";
import BriefStatsLoading from './loading/BriefStatsLoading';


/** Default new widget */
const NEW_WIDGET = {
    "type": "text",
    "value": "",
    "model": "Zitat",
    "field": "Text",
    "flat_field": "beleganalyse_metapherManifestation",
};

/** milliseconds before automatic search update */
const DEBOUNCE_TIMEOUT = 100;


class SearchStatefulComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            waitingForResult: false,
            inputMode: "weniger",
            outputMode: "Zitate",
            prevOutputMode: "",
            columns: [], // own search properties
            result_columns: [],  // search properties as response from server
            search_url: props.search_url,
            widget_types: props.widget_types,
            autocomplete: props.autocomplete,
            hide_search: props.hide_search,
            enabledViews: { "Liste": true },
            results: {},
            cur_page: 0,
            prev_page: 0,
            popup_pk: 0,
        };
        this.do_request = false;
        this.state["flat_field_to_model_field"] = this._flat_field_to_model_field();
        this.state["columns"] = this.getColumnsFromUrlParams();
        this.sendRequest = _.debounce(
            this.sendRequestNow,
            DEBOUNCE_TIMEOUT
            //, {trailing: true, leading: false})();
        );
    }

    _flat_field_to_model_field() {
        let mapping = {};
        for (let i = 0; i < this.state.widget_types.length; ++i) {
            const model = this.state.widget_types[i];
            for (let j = 0; j < model.fields.length; ++j) {
                const field = model.fields[j];
                mapping[field.field] = [model.model, field.name]
            }
        }
        return mapping;
    }

    componentDidMount() {
        // update widgets from change of url hash
        if (!this.state.hide_search)
            $(window).on('hashchange', this.onHashChange);

        // send search request, if a value is already given
        if (this.state.columns.length && this.state.columns[0].length &&
            this.state.columns[0][0].value.length)
            this.sendRequest();
        else
            if (this.state.hide_search)
                this.sendRequest();
    }

    componentWillUnmount() {
        $(window).off('hashchange', this.onHashChange);
    }

    componentDidUpdate() {
        if (this.do_request) {
            this.do_request = false;
            if (this.hasSearchChanged()) {
                this.sendRequest();
            }
        }
    }

    setValueChanged() {
        this.setState({
            waitingForResult: true
        });
    }

    onHashChange = () => {
        const hash = window.location.hash;
        const cur_hash = columnsToHash(this.state.columns);
        if (hash === cur_hash)
            return;

        const columns = this.getColumnsFromUrlParams();
        if (columns.length) {
            this.do_request = true;
            this.setState((state, props) => {
                return { columns: columns, popup_pk: 0 };
            });
        }
    };

    /**
     * Returns the search widget columns from current url parameters
     * @returns Array
     */
    getColumnsFromUrlParams = () => {
        let columns = hashToColumns(window.location.hash, this.state.widget_types);

        // default
        if (!columns.length)
            columns = [[NEW_WIDGET]];

        return columns;
    };

    /** Store search params to component-state.
     * If this.do_request is true, sendRequest will be executed on state update */
    setColumns = (columns) => {
        window.location.hash = columnsToHash(columns);
        this.setState({ columns });
    };

    hasSearchChanged = () => {
        return (
            this.state.outputMode !== this.state.prevOutputMode
            || this.state.cur_page !== this.state.prev_page
            || JSON.stringify(this.state.columns) !== JSON.stringify(this.state.result_columns)
        );
    };

    /** Get search results from server with current search params in component-state */
    sendRequestNow = () => {
        if (!this.hasSearchChanged())
            return;
        this.setValueChanged();
        if (this.state.lastSentXhr)
            this.state.lastSentXhr.abort()
        const xhr = $.ajax({
            url: this.state.search_url,
            method: "PUT",
            dataType: "json",
            data: JSON.stringify({
                columns: this.state.columns,
                output_mode: this.state.outputMode,
                page: this.state.cur_page,
            }),
            success: (data) => {
                data.result_columns = JSON.parse(JSON.stringify(data.columns));
                data.waitingForResult = false;
                data.prevOutputMode = this.state.outputMode;
                data.prev_page = this.state.cur_page;
                this.setState(data);
            }
        });
        this.setState({
            lastSentXhr: xhr
        })
    };

    onOutputMode = (value) => {
        this.do_request = true;
        this.setState((state, props) => (
            { outputMode: value }
        ));
    };

    onSearchClick = () => {
        this.sendRequestNow();
    };

    onPlusClick = (xy) => {
        if (xy[0] >= this.state.columns.length) {
            this.setColumns(this.state.columns.concat([[NEW_WIDGET]]));
        }
        else {
            this.setColumns(
                this.state.columns.map((col, x) => {
                    if (xy[0] === x) {
                        return col.concat([NEW_WIDGET]);
                    }
                    else return col;
                }
                ));
        }
    };

    onFieldChange = (xy, model, flat_field) => {
        const fields_def = this.state.widget_types.filter((w) => (w.model === model))[0].fields;

        // check correct field on model change, or jump back to first
        if (model !== this.state.columns[xy[0]][xy[1]].model) {
            const old_field_name = this.state.flat_field_to_model_field[flat_field][1];
            // try field definition by verbose old name
            const field_def = fields_def.filter((f) => (f.name === old_field_name));
            if (field_def.length === 0) {
                flat_field = fields_def[0].field;
            } else {
                flat_field = field_def[0].field
            }
        }
        const field_def = fields_def.filter((f) => (f.field === flat_field))[0];

        let columns = JSON.parse(JSON.stringify(this.state.columns));
        let widget = columns[xy[0]][xy[1]];

        columns[xy[0]][xy[1]] = {
            ...widget,
            model: model,
            type: field_def.type,
            field: field_def.name,
            flat_field: field_def.field,
        };
        this.setColumns(columns);
    };

    onValueChange = (xy, value, do_request) => {

        let cur_columns_json = JSON.stringify(this.state.columns);
        let columns = JSON.parse(cur_columns_json);
        let widget = columns[xy[0]][xy[1]];

        columns[xy[0]][xy[1]] = {
            ...widget,
            value: value,
        };

        if (do_request && cur_columns_json !== JSON.stringify(columns)) {
            this.do_request = true;
            //this.setValueChanged();
        }

        this.setColumns(columns);
    };

    onDelete = (xy) => {
        this.do_request = true;
        let columns = JSON.parse(JSON.stringify(this.state.columns));

        columns[xy[0]].splice(xy[1], 1);
        if (columns[xy[0]].length === 0)
            columns.splice(xy[0], 1);

        this.setColumns(columns);
    };

    onShowZitat = (pk) => {
        this.setState((state, props) => ({
            popup_pk: pk
        }));
    };

    onHideZitat = () => {
        this.setState((state, props) => ({
            popup_pk: 0
        }));
    };

    /** pagination in ZitateList */
    onPageChange = (page) => {
        this.setValueChanged();
        this.do_request = true;
        this.setState((state, props) => ({
            cur_page: page
        }))
    };

    render() {
        const valuesChanged = JSON.stringify(this.state.columns) !== JSON.stringify(this.state.result_columns);
        return (
            <div>
                {/*<pre>{columnsToHash(this.state.columns)}</pre>*/}
                {/*<pre>{JSON.stringify(
                    hashToColumns(columnsToHash(this.state.columns), this.state.widget_types), null, " ")}</pre>
                    */}
                {!this.state.hide_search && (
                    <div>
                        <QueryMatrix
                            columns={this.state.columns}
                            enabled={!this.state.waitingForResult && valuesChanged}
                            widgetTypes={this.state.widget_types}
                            autocomplete={this.state.autocomplete}
                            onFieldChange={this.onFieldChange}
                            onValueChange={this.onValueChange}
                            onPlusClick={this.onPlusClick}
                            onSearchClick={this.onSearchClick}
                            onDelete={this.onDelete}
                        />

                        <hr />
                    </div>
                )}

                {/* <Spinner active={this.state.waitingForResult}/> */}

                {!this.state.hide_search &&
                    <BriefTitle columns={this.state.result_columns} />
                }

                <div className={"grid-x grid-margin-x"}>

                        <div className={"small-8 cell"}>

                            {this.state.results.count ?
                                <div>
                                    <ApexTimeline
                                        timeline={this.state.results.timeline}
                                        onZitatClick={this.onShowZitat}
                                    />
                                </div>
                                : !this.state.results.count && this.state.waitingForResult ?
                                    <div>
                                        <ApexTimeline
                                            timeline={{
                                                endY: 21,
                                                items: [],
                                                startY: -2
                                            }}
                                            onZitatClick={this.onShowZitat}
                                        />
                                    </div>
                                    : null
                            }

                            <br />
                            {true ?
                                <Tabs
                                    choices={["Zitate", "Tabelle"]}
                                    value={this.state.outputMode}
                                    onClick={this.onOutputMode}
                                />
                                : null
                            }
                            <SearchResults
                                results={this.state.results}
                                onRowClick={this.onShowZitat}
                                onPageChange={this.onPageChange}
                                onShowZitat={this.onShowZitat}
                                hideSearch={this.state.hide_search}
                                loading={this.state.waitingForResult}
                                outputMode={this.state.outputMode}
                            />

                        </div>

                        <div className={"small-4 cell"}>

                            {this.state.results.count ?
                                <BriefStats
                                    stats={this.state.results.brief_stats}
                                    numCitations={this.state.results.count}
                                />
                                : !this.state.results.count && this.state.waitingForResult ?
                                    <BriefStatsLoading />
                                    : null
                            }

                        </div>
                </div>

                {!this.state.popup_pk ? null :
                    <ZitatPopup pk={this.state.popup_pk} onClose={this.onHideZitat}
                        onChangeZitat={this.onShowZitat}
                    />
                }
            </div>
        );
    }
}

export default SearchStatefulComponent;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/SearchStatefulComponent.js